import React, { useState } from 'react'
import Navbar from '../../Navbar'
import Sidebar from '../../Sidebar'

import { InfoContainer, InfoWrapper, SectionTitle } from './MarketplaceElements'

const Marketplace = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }
  return (
    <>
      <Navbar toggle={toggle} info='Playground' />
      <Sidebar isOpen={isOpen} toggle={toggle} info='Playground' />
      <InfoContainer>
        <InfoWrapper>
          <SectionTitle>Marketplace</SectionTitle>
        </InfoWrapper>
      </InfoContainer>
    </>
  )
}

export default Marketplace
